import React, { useState } from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';

interface FlagPatientButtonProps {
  disabled?: boolean;
  onFlagChange: () => Promise<void>;
  loadFlaggedData?: boolean;
}

const FlagPatientButton: React.FC<FlagPatientButtonProps> = ({
  disabled = false,
  onFlagChange,
  loadFlaggedData = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const tooltipText = loadFlaggedData ? 'Unflag Patient' : 'Flag Patient';

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row expansion
    if (isProcessing) return;

    setIsProcessing(true);
    try {
      await onFlagChange();
    } catch (error) {
      console.error('Flag operation failed:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <span>
        <IconButton
          size="small"
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          disabled={disabled || isProcessing}
          sx={{
            transition: 'all 0.2s ease-in-out',
            color: isHovered || loadFlaggedData ? '#D32F2F' : '#9E9E9E',
            '&:hover': {
              color: '#D32F2F',
              backgroundColor: 'rgba(211, 47, 47, 0.08)',
            },
            '&.Mui-disabled': { color: '#BDBDBD' },
          }}
        >
          {isProcessing ? (
            <CircularProgress size={16} sx={{ color: '#D32F2F' }} />
          ) : isHovered || loadFlaggedData ? (
            <FlagIcon sx={{ fontSize: 20 }} />
          ) : (
            <FlagOutlinedIcon sx={{ fontSize: 20 }} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default FlagPatientButton;
